/******
 * This file was generated by a Rake task.
 * Do not modify this file manually.
 * Add changes to the `Message.ts` file.
 ******/
// oxlint-disable-next-line no-unused-vars
import dayjs, { Dayjs } from "dayjs";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";
dayjs.extend(utc);
dayjs.extend(timezone);

import { Message } from "./Message";

import { Notification } from "./Notification";
import { Project } from "./Project";
import { Team } from "./Team";
import { User } from "./User";

export type messageType = "alert" | "delivery" | "logistic" | "request_to_join_project" | "request_to_join_team";

export const messageTypeValues = {
    alert: 0,
    delivery: 1,
    logistic: 2,
    request_to_join_project: 3,
    request_to_join_team: 4,
};

export abstract class MessageModel {
    id: number;
    archived: boolean;
    body: string;
    createdAt: Dayjs;
    messageType: messageType;
    projectId: number | null;
    senderId: number | null;
    teamId: number | null;
    updatedAt: Dayjs;
    notifications: Notification[] | undefined;
    project: Project | null | undefined;
    sender: User | null | undefined;
    team: Team | null | undefined;
    _destroy: boolean | undefined;

    /* eslint-disable max-statements */
    constructor(
        id: number,
        archived: boolean,
        body: string,
        createdAt: Dayjs,
        messageType: messageType,
        projectId: number | null,
        senderId: number | null,
        teamId: number | null,
        updatedAt: Dayjs,
        notifications: Notification[] | undefined,
        project: Project | null | undefined,
        sender: User | null | undefined,
        team: Team | null | undefined
    ) {
        this.id = id;
        this.archived = archived;
        this.body = body;
        this.createdAt = createdAt;
        this.messageType = messageType;
        this.projectId = projectId;
        this.senderId = senderId;
        this.teamId = teamId;
        this.updatedAt = updatedAt;
        this.notifications = notifications;
        this.project = project;
        this.sender = sender;
        this.team = team;
    }
    /* eslint-enable max-statements */

    // oxlint-disable-next-line complexity
    static fromApiObject(json: any, timezone: string): Message {
        const newObject = new Message(
            json["id"],
            json["archived"],
            json["body"],
            dayjs(json["created_at"]).tz(timezone),
            json["message_type"],
            json["project_id"],
            json["sender_id"],
            json["team_id"],
            dayjs(json["updated_at"]).tz(timezone),
            json["notifications"]?.map((item: any) => Notification.fromApiObject(item, timezone)),
            json["project"] == null ? json["project"] : Project.fromApiObject(json["project"], timezone),
            json["sender"] == null ? json["sender"] : User.fromApiObject(json["sender"], timezone),
            json["team"] == null ? json["team"] : Team.fromApiObject(json["team"], timezone)
        );

        return newObject;
    }

    // oxlint-disable-next-line complexity
    toApiObject(visited = new Set<any>()): any {
        if (visited.has(this)) {
            // Return null, undefined, or primary key to break the cycle
            return undefined;
        }
        visited.add(this);

        return {
            id: this.id,
            archived: this.archived,
            body: this.body,
            created_at: this.createdAt,
            message_type: this.messageType,
            project_id: this.projectId,
            sender_id: this.senderId,
            team_id: this.teamId,
            updated_at: this.updatedAt,
            notifications: this.notifications
                ?.map((item) => item.toApiObject(visited))
                .filter((item) => item !== undefined),
            project_attributes: this.project?.toApiObject(visited),
            sender_attributes: this.sender?.toApiObject(visited),
            team_attributes: this.team?.toApiObject(visited),
            _destroy: this._destroy,
        };
    }

    // NOTE: This could potentially cause infinite loops if the object graph is
    // circular.
    inAlternateTimezone(timezone: string): Message {
        const clone = Object.create(this) as Message;

        for (const key of Object.keys(this)) {
            if (this[key] instanceof dayjs) {
                // @ts-expect-error: Typescript thinks that this is not a dayjs object even though it is checked on the line before
                clone[key] = this[key].tz(timezone);
            } else if (Array.isArray(this[key])) {
                clone[key] = this[key].map((item) =>
                    item.inAlternateTimezone ? item.inAlternateTimezone(timezone) : item
                );
            } else if (this[key] && this[key].inAlternateTimezone) {
                clone[key] = this[key].inAlternateTimezone(timezone);
            }
        }

        return clone;
    }
}
